import React from "react";
import phones from "../images/phones-color.svg";
import logo from "../images/main-logo.png";

const Message = (props) => {
    const {data, message, role, isLastInChain, avatar, dataKey} = props;

    const text = (!data) ? message : (data?.title ? data.title : null);

    if (!text) {
        return <></>;
    }

    return <div className={"message-box " + role} key={'mss_' + dataKey}>
        {
            role !== "CUSTOMER" && <div className={"avatar" + (isLastInChain ? " message__last" : "")}>
                <img role={"none"} className={"u291_img " + (role === "AGENT" ? "phones" : "")} width={16} height={26}
                     src={avatar ? avatar : (role === "AGENT" ? phones : logo)}/>
            </div>
        }
        <div className={"message " + role + (isLastInChain ? " message__last" : "")}>
            <div>
                <div dangerouslySetInnerHTML={{__html: text}}/>
            </div>
        </div>
    </div>
}

export default Message;
